import { createSelector } from 'reselect';
import { StateType } from './reducer';

const getReducer = (state) => state.global;

export const clientIdSelector = createSelector<StateType, string, string>(
  (state) => getReducer(state).clientId,
  (clientId) => clientId
);

export const currentBrandSelector = createSelector<StateType, string, string>(
  (state) => getReducer(state).currentBrand,
  (currentBrand) => currentBrand
);

export const enterpriseBrandSelector = createSelector<StateType, string, string>(
  (state) => getReducer(state).enterpriseBrand,
  (enterpriseBrand) => enterpriseBrand
);

export const isEnterpriseContextSelector = createSelector<StateType, string, boolean>(
  (state) => getReducer(state).enterpriseBrand,
  (enterpriseBrand) => enterpriseBrand !== null
);

export const isBrandFilterableSelector = createSelector<StateType, boolean, boolean>(
  (state) => getReducer(state).isBrandFilterable,
  (isBrandFilterable) => isBrandFilterable
);

export const isWhiteListedForCampaignSelector = createSelector<StateType, boolean, boolean>(
  (state) => getReducer(state).isWhiteListedForCampaign,
  (isWhiteListedForCampaign) => isWhiteListedForCampaign
);
